import { useEffect, useState } from "react";
import api, { fmtDate } from "@/lib/api";
import { PageHeader, Loader, EmptyState } from "@/components/ui-kit";
import { Button } from "@/components/ui/button";
import { Bell, CheckCheck, BellRing } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/notifications").then((r) => setItems(r.data));
  useEffect(() => { load(); const iv = setInterval(load, 15000); return () => clearInterval(iv); }, []);

  const readAll = async () => { await api.patch("/notifications/read-all"); load(); };
  const readOne = async (id) => { await api.patch(`/notifications/${id}/read`); load(); };

  return (
    <div>
      <PageHeader title="Notifications" subtitle="Alertes et évènements automatiques">
        <Button variant="outline" onClick={readAll} data-testid="read-all"><CheckCheck className="h-4 w-4 mr-1.5" />Tout marquer comme lu</Button>
      </PageHeader>
      {items === null ? <Loader /> : items.length === 0 ? (
        <EmptyState icon={Bell} title="Aucune notification" subtitle="Vous êtes à jour." />
      ) : (
        <div className="space-y-2 max-w-3xl">
          {items.map((n) => (
            <button key={n.id} onClick={() => readOne(n.id)} data-testid={`notif-${n.id}`}
              className={`flex w-full items-start gap-3 rounded-xl border p-4 text-left transition-colors ${n.read ? "bg-white" : "bg-brand-50/60 border-brand-200"}`}>
              <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${n.read ? "bg-slate-100 text-slate-400" : "bg-brand-100 text-brand-600"}`}>
                {n.read ? <Bell className="h-4 w-4" /> : <BellRing className="h-4 w-4" />}
              </div>
              <div className="flex-1">
                <p className={`text-sm ${n.read ? "text-slate-600" : "font-semibold text-slate-800"}`}>{n.message}</p>
                <p className="text-xs text-slate-400 mt-0.5 font-mono">{fmtDate(n.created_at)}</p>
              </div>
              {!n.read && <span className="h-2 w-2 rounded-full bg-brand-500 mt-2" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
